export default "__VITE_ASSET__2df93500__"